import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';

export default buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);
